<template>
    <div>
        <h2>{{ isEdit ? 'Modification' : 'Création' }} de modèle</h2>
        <!-- Form fields for the model would go here -->
        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="label_model" class="form-label fw-bold">Libellé du modèle*</label>
                <input type="text" class="form-control" id="label_model" placeholder="Libellé du modèle"
                    v-model="formData.label" required>
                <small class="text-danger" v-if="errors['label']">{{ errors['label'][0] }}</small>

            </div>

            <div class="mb-3 col-md-6">
                <label for="price_model" class="form-label">Prix du modèle</label>
                <input type="number" class="form-control" id="price_model" placeholder="Libellé du modèle"
                    v-model="formData.price">
            </div>

            <div class="mb-3 col-md-6">
                <label for="image_model" class="form-label">Image</label>
                <input type="file" class="form-control" id="image_model" placeholder="Image du modèle"
                    @change="takeFileInput($event, 'image')">
            </div>
            <div>
                <img :src="imageUrl" class="image-preview" />
                <!-- <img src="@/assets/default.png" id="image-preview" /> -->
            </div>
            <div class="mb-3 col-md-6">
                <label for="commentaire_model" class="form-label">Commentaire</label>
                <textarea class="form-control" id="commentaire_model" rows="5"
                    placeholder="Infomations supplémentaires..." v-model="formData.commentaire"></textarea>
            </div>

            <div class="mb-3 col-md-6">
                <label for="next_rdv_model" class="form-label">Prochain rendez-vous</label>
                <input type="date" class="form-control" id="next_rdv_model" placeholder="Prochain rendez-vous"
                    v-model="formData.next_rdv">
            </div>

        </div>

        <div class="row mt-2">
            <div class="col text-end">
                <button class="btn btn-success" @click="save"><i
                        class="bi bi-check-circle me-1"></i>Enregistrer</button>
                <button type="button" class="btn btn-secondary mx-2" @click="$router.push(cancelLink)"><i
                        class="bi bi-x-circle me-1"></i>Annuler</button>

            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
export default {
    name: 'ModelForm',
    mixins: [formMixin],
    props: {
        client_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            defaultData: {
                nom: ''
            },
            url: '/styles',
            datesCols: ['next_rdv'],
        }
    },
    computed: {
        imageUrl() {
            return this.imageLink('image');
        },
        cancelLink() {
            return this.isEdit ?
                {
                    name: 'models.view',
                    params: {
                        id: this.item.id
                    }
                }
                :
                {
                    name: 'clients.view',
                    params: {
                        id: this.client_id
                    }
                }
        }
    },
    methods: {
        beforeSave() {
            this.formData.is_active = this.item?.is_active ? 1 : 0
            this.formData.client_id = this.client_id;
        }
    }

}
</script>
